var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "login--form" } }, [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", [
          _c("h1", { staticClass: "modal-header" }, [
            _c("strong", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: _vm.langRoot + ".title",
                  expression: "`${langRoot}.title`"
                }
              ]
            })
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: _vm.langRoot + ".helper",
                expression: "`${langRoot}.helper`"
              }
            ],
            attrs: { "data-ci": "recover-username-message" }
          }),
          _vm._v(" "),
          _c("br")
        ]),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c("div", { staticClass: "level" }, [
            _c("div", { staticClass: "level-left" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "level-right" }, [
              _c("button", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".okBtn",
                    expression: "`${langRoot}.okBtn`"
                  }
                ],
                staticClass: "btn primary",
                on: {
                  click: function($event) {
                    return _vm.goToLoginPage()
                  }
                }
              })
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8af586c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8af586c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/Components/RecoverUser.vue
// module id = 99fZ
// module chunks = 1